import { selectCaseByPage } from "../../api";

const plan = {
  namespaced: true,

  state: {
    planList: [],
    limit: 16,
    total: 0,
  },

  getters: {
    planList: (state) => state.planList,
    total: (state) => state.total,
  },

  mutations: {
    SET_PLAN_LIST(state, list) {
      state.planList = list;
    },

    SET_TOTAL(state, total) {
      state.total = total;
    },
  },

  actions: {
    async selectCaseByPage({ commit, state }, payload) {
      const { fileName, pageNum } = payload;
      const response = await selectCaseByPage(fileName, pageNum, state.limit);
      if (response.code === 200) {
        commit("SET_PLAN_LIST", response.data.list);
        commit("SET_TOTAL", response.data.total);
      }
    },
  },
};

export default plan;
